<template>
  <div class="pdf-viewer-container">
    <iframe
      v-if="!isMobile"
      :src="pdfUrl"
      class="pdf-iframe"
      frameborder="0"
      allowfullscreen
      type="application/pdf"
    ></iframe>
    <div v-else class="mobile-fallback">
      <p class="fallback-message">正在为您打开 PDF 文件...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CallToActionPDF",
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    pdfUrl() {
      return 'https://gf60.org.cn/upload/owe/9a95dd0d7a09410aa4550bea4552a3c9.pdf'
    },
  },
  mounted() {
    this.detectMobile();
    if (this.isMobile) {
      // 移动设备直接跳转到 PDF 源文件
      window.location.href = this.pdfUrl;
    }
  },
  methods: {
    detectMobile() {
      // 检测是否为移动设备
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      this.isMobile = mobileRegex.test(userAgent.toLowerCase());
      
      // 也可以通过屏幕宽度判断
      if (!this.isMobile && window.innerWidth <= 768) {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style scoped lang="less">
.pdf-viewer-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.mobile-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
}

.fallback-message {
  font-size: 16px;
  color: #666;
}

@media screen and (max-width: 767px) {
  .pdf-viewer-container {
    padding: 0;
  }
  
  .fallback-message {
    font-size: 14px;
  }
}
</style>

